import { ChangeDetectionStrategy, Component } from '@angular/core';

import { Store, createSelector } from '@ngrx/store';
import { Observable } from 'rxjs';

import { betslipSelector } from '../../../../base/store/selectors';
import { IBetslipRootState, IBetslipState } from '../../../../base/store/state';
import { BetslipNotificationMessageType, IBetslipNotificationState } from '../../../notifications/state';

interface IBetslipEditMyBetBottomMessageProps {
    notification: IBetslipNotificationState;
    isVisible: boolean;
}

const notificationSelector = createSelector(
    betslipSelector,

    (betslipState: IBetslipState): IBetslipEditMyBetBottomMessageProps => {
        const state = betslipState.notifications;

        return {
            notification: state,
            isVisible: !!state && state.messageType !== BetslipNotificationMessageType.NotSet,
        };
    },
);

@Component({
    selector: 'bs-betslip-edit-my-bet-bottom-message',
    templateUrl: './edit-bet-bottom-message.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./edit-bet-bottom-message.component.scss'],
    standalone: false,
})
export class EditMyBetBottomMessageComponent {
    props$: Observable<IBetslipEditMyBetBottomMessageProps>;

    constructor(store: Store<IBetslipRootState>) {
        this.props$ = store.select(notificationSelector);
    }
}
